export default {
  id: '',
  name: '',
  brandID: '',
  brandName: '',
  brandInfo: {},
  socials: {},
  doctorURL: {},
  coBrandLogoURL: '',
  appType: '',
  appAlexa: '',
  healthBlog: '',
  vaInOut: null,
  includeMedical: false,
  includeMedicalChart: false,
  includePharmacy: false,
  includeDental: false,
  includeVision: false,
  includeBenefitDetails: false,
  includeLifeDisability: false,
  includeVoluntary: false,
  includeHowPlanWorks: false,
  includeMoreEnrollmentMaterials: false,
  contactUs: {},
  oeMaterials: {
    oeStart: '',
    enrollText: '',
    oeEnd: '',
    enrollURL: '',
    oeBrochure: {
      oeBrochureLabel: '',
      oeBrochureURL: []
    }
  },
  moreEnrollmentMaterials: {
    resource: []
  },
  benefitDetails: {
    resource: [
      {
        label: '',
        url: ''
      }
    ]
  },
  medical: {
    medicalPlansChart: {
      labelsChart: {},
      planChart: [],
      planChartFootnotes: ''
    },
    planMedical: [],
    planMedicalHash: {}
  },
  dental: {
    dentalPlans: {
      planDental: []
    }
  },
  vision: {
    visionPlanBullets: {
      eyeExams: false,
      eyeglasses: false,
      pediatricEyeExams: false,
      pediatricEyeglasses: false
    },
    visionPlanChart: {
      headerVision: '',
      eyeExams: '',
      eyeglassFrames: '',
      eyeglassLenses: '',
      disposableContacts: '',
      nondisposableContacts: ''
    },
    visionDisclosure: ''
  },
  lifeAndDisability: {
    lifeInsurance: false,
    longDisability: false
  },
  voluntary: {
    accidentBenefits: false,
    hospitalIndemnity: false
  },
  guidance: {
    resource: [],
    resourcesMap: null,
    includeBlueCard: false,
    inlcudeBlueDistinctionTC: false,
    includeAutism: false,
    includeBHServ: false,
    includeCancerRes: false,
    includeCaseManag: false,
    includeCondCare: false,
    includeCondCareEnd: false,
    includeCondCareSup: false,
    includeFertilitySupp: false,
    includeShopper: false,
    includeDiabetes: '',
    includeLiveHealthy: ''
  },
  wellness: { resource: [], resourcesMap: null },
  wellnessResources: {
    includeWorkPlacePackage: '',
    includeWorkSiteWellness: false,
    includeGymReimb: false,
    includeHealthyLife: false,
    includeMyHealthAdv: false,
    includeMyHealthC: false,
    includeOnlineKit: false,
    includeSpecOffers: false,
    includeStayHR: '',
    includeWeightCenter: false,
    includeCommuter: false,
    includeEAP: false,
    includeProdSolutions: false,
    includeWorkLife: false,
    includeAntHRwrd: false
  },
  pharmacy: {
    summary: '',
    accessPharmacies: '',
    specialtyDrugs: '',
    preventiveDrugs: '',
    payDeductible: '',
    shareCosts: '',
    pharmacyHomeDelivery: false,
    pharmacyFAQURL: false,
    pharmacyASO: false,
    netWorks: {
      network: [{ name: '', summary: '' }]
    },
    drugList: {
      link: []
    }
  },
  published: false
};
